
export default function Terms() {
  return (
    <div className="min-h-screen bg-gray-900 py-20">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="bg-gray-800 rounded-xl p-8 lg:p-12 border border-gray-700">
          <div className="text-center mb-8">
            <p className="text-teal-400 text-lg font-semibold mb-2">Effective November 1, 2025</p>
            <h1 className="text-4xl font-bold text-white">Terms and Conditions</h1>
          </div>
          
          <div className="prose prose-invert max-w-none">
            <div className="text-gray-300 leading-relaxed space-y-6">
              <p>
                These terms and conditions (the "Terms and Conditions") govern the use of www.ugofrederick.com (the "Site"). This Site is owned and operated by Ugochukwu Frederick.
              </p>
              
              <p>
                By using this Site, you indicate that you have read and understood these Terms and Conditions and agree to abide by them at all times.
              </p>
              
              <h2 className="text-2xl font-bold text-white mt-8 mb-4">Intellectual Property</h2>
              <p>
                All content published and made available on our Site is the property of Ugo Frederick and the Site's creators. This includes, but is not limited to images, text, logos, documents, and downloadable files.
              </p>
              
              <h2 className="text-2xl font-bold text-white mt-8 mb-4">Indemnity</h2>
              <p>
                Except where prohibited by law, by using this Site you indemnify and hold harmless the site owners from any actions, claims, losses, damages, liabilities, and expenses including legal fees arising out of your use of our Site or your violation of these Terms and Conditions.
              </p>
              
              <h2 className="text-2xl font-bold text-white mt-8 mb-4">Changes</h2>
              <p>
                These Terms and Conditions may be amended from time to time as deemed necessary to continue to remain compliant with the law and to reflect any change in the way we operate our Site and the expectation of users on our Site.
              </p>
              
              <h2 className="text-2xl font-bold text-white mt-8 mb-4">Contact Details</h2>
              <p>
                Please contact us if you have any questions or concerns.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}